export default __webpack_public_path__ + "static/Efficacy-TSAT-Changes-chart2-SM@2x-068a2d1ad83aaf36036286c023047aef.png";